import service from '../services/flow';
import flowHandler from '../handlers/flow';
import { Config } from '../core/config';
import { model } from '../core/model';
import view from '../helpers/view';
import meteringHelper from '../../common/helpers/metering-api-fetch';

const SUSCRIBEMODE = "S";

const flowA = function () {

    try {
        if (model.Usuario.isLoggued()) {
            meteringHelper.obtenerCookieSuscriptor(Config.apiAuthorize, model.Usuario.xToken, Config.apiAuthorizeInfo)
                .then(() => {
                    const comboNumber = 
                    model.Window.modo.toUpperCase() !== SUSCRIBEMODE &&
                    model.ProductCategory !== "Foodit"
                    ? model.Window.combo : 1 ;
                    service.getFlow({ flow: 'A', combo: comboNumber })
                        .then(data => {
                            model.Window.lastFlow = 'A'
                            switch (comboNumber) {
                                case Config.PRODUCTO_NOTA:
                                    flowHandler.flowA(data)
                                    break;
                                case Config.PRODUCTO_PDF:
                                    flowHandler.flowAPdf(data)
                                    break;
                            }
                        })
                        .catch(err => {
                            console.log('err', err);
                            flowHandler.flowDefault();
                            view.hidePreloader();
                        });
                });
        }
        else {
            flowHandler.flowDefault();
            view.hidePreloader();
        }
    }
    catch (ex) {
        window.mostrar_error({
            error: `flowController.flowA | No anduvo el flow`
        })
    }

}

const flowABis = function () {

    try {
        if (model.Usuario.isLoggued()) {
            meteringHelper.obtenerCookieSuscriptor(Config.apiAuthorize, model.Usuario.xToken, Config.apiAuthorizeInfo)
                .then(() => {
                    service.getFlow({ flow: 'A', combo: model.Window.combo })
                        .then(data => {
                            switch (model.Window.combo) {
                                case Config.PRODUCTO_NOTA:
                                    flowHandler.flowABis(data)
                                    break;
                                case Config.PRODUCTO_PDF:
                                    flowHandler.flowAPdf(data)
                                    break;
                            }
                        })
                        .catch(err => {
                            console.log('err', err);
                            flowHandler.flowDefault();
                            view.hidePreloader();
                        });
                });
        }

        else {
            flowHandler.flowDefault();
            view.hidePreloader();
        }
    }
    catch (ex) {
        window.mostrar_error({
            error: `flowController.flowABis | No anduvo el flow`
        })
    }

}

const flowS = function () {
    flowHandler.flowDefault();
    view.hidePreloader();
}

export default {
    flowA,
    flowABis,
    flowS
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/flow.js